import { useEffect, useState } from 'react';
import { Brain, Sparkles } from 'lucide-react';
import { useChatStore } from '@/stores/chatStore';
import { TypingIndicator } from '@/components/ui';

const SMOKE_THRESHOLD_MS = 5 * 1000;

export default function LoadingMessage() {
  const isLoading = useChatStore((s) => s.isLoading);
  const reasoning = useChatStore((s) => s.reasoning);
  const loadingStartedAt = useChatStore((s) => s.loadingStartedAt);
  const [isSmoking, setIsSmoking] = useState(false);

  useEffect(() => {
    if (!isLoading || !loadingStartedAt) {
      setIsSmoking(false);
      return;
    }

    // Check immediately in case already past threshold
    const elapsed = Date.now() - loadingStartedAt;
    if (elapsed >= SMOKE_THRESHOLD_MS) {
      setIsSmoking(true);
      return;
    }

    // Schedule check for when threshold is reached
    const timer = setTimeout(() => {
      setIsSmoking(true);
    }, SMOKE_THRESHOLD_MS - elapsed);

    return () => clearTimeout(timer);
  }, [isLoading, loadingStartedAt]);

  if (!isLoading) return null;

  return (
    <div className="flex flex-col gap-2 message-enter">
      <div className="flex items-center gap-2.5">
        <div className="relative w-8 h-8 rounded-lg flex items-center justify-center text-sm bg-gradient-to-br from-accent-blue via-accent-purple to-accent-blue/80 text-white shadow-lg shadow-accent-blue/20">
          <Brain size={16} />
          {isSmoking && (
            <div className="absolute -top-1 left-0 w-full h-4 pointer-events-none overflow-visible">
              <span className="brain-smoke" style={{ left: '20%', animationDelay: '0s' }} />
              <span className="brain-smoke" style={{ left: '50%', animationDelay: '0.6s' }} />
              <span className="brain-smoke" style={{ left: '75%', animationDelay: '1.2s' }} />
            </div>
          )}
        </div>
        <span className="text-xs font-semibold text-text-secondary">Ares</span>
        <Sparkles size={12} className="text-accent-purple animate-pulse-soft" />
      </div>
      
      {reasoning ? (
        <div className="glass-card border-accent-purple/20 rounded-lg px-3 py-2.5">
          <div className="text-[11px] text-text-muted mb-2 flex items-center gap-1.5">
            <Brain size={10} className="text-accent-purple" />
            <span className="font-semibold text-accent-purple">Analizando...</span>
          </div>
          <p className="text-xs text-text-secondary">{reasoning}</p>
        </div>
      ) : (
        <div className="glass-card rounded-xl px-3 py-3">
          <TypingIndicator />
        </div>
      )}
    </div>
  );
}
